// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8676e7a","status":"_3df1945","team":"_d210718","teamA":"_3801e74","teamB":"_fdeb8d5","score":"_fa80512","teamAScore":"_36e1460","teamBScore":"_ee32ebb"};